import ComplaintModal from './ComplaintModal'
export default ComplaintModal
